/** @format */

import React, { useEffect, useRef } from 'react'
import styled from 'styled-components'
import { Controlled } from 'react-codemirror2'
import 'codemirror/lib/codemirror.css'
import 'codemirror/theme/material.css'
import 'codemirror/mode/yaml/yaml'

interface YamlCodemirrorProps {
  className?: string
  value: string
  onChange?: (value: string) => void
  visible?: boolean // 添加 visible 属性，用于在 Drawer/Dialog 中控制刷新
}
const YamlCodemirror: React.FC<YamlCodemirrorProps> = ({
  className,
  value = '',
  onChange,
  visible
}) => {
  const editorRef = useRef<any>(null)

  // 当 visible 变为 true 时，刷新 CodeMirror 以确保正确渲染
  useEffect(() => {
    if (visible && editorRef.current) {
      // 延迟刷新，确保 Drawer 动画完成
      const timer = setTimeout(() => {
        editorRef.current?.refresh()
      }, 100)
      return () => clearTimeout(timer)
    }
  }, [visible])

  return (
    <Controlled
      className={className}
      value={value}
      editorDidMount={editor => {
        editorRef.current = editor
        // 如果已经可见，立即刷新
        if (visible !== false) {
          setTimeout(() => {
            editor.refresh()
          }, 100)
        }
      }}
      options={{
        mode: 'yaml',
        theme: 'material',
        lineNumbers: true,
        lineWrapping: true
      }}
      onBeforeChange={(editor, data, value) => {
        onChange?.(value)
      }}
    />
  )
}

export default styled(YamlCodemirror)`
  .CodeMirror {
    height: 500px;
  }
`
